import { Link } from "react-router-dom";
import type { NewsArticle } from "@/types";

export default function NewsCard({ article }: { article: NewsArticle }) {
  return (
    <Link
      to={`/news/${article.id}`}
      className="group flex flex-col gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 sm:flex-row"
    >
      <div className="w-full shrink-0 overflow-hidden rounded-md bg-background-200 sm:w-56">
        <div className="h-44 w-full sm:h-32">
          <img
            src={article.cover}
            alt={article.title}
            title={`${article.title} - 91看片影视资讯`}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.date}
          </span>
          <span>{article.author}</span>
        </div>
        <h3 className="mt-2 line-clamp-2 text-base font-bold text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          {article.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-6 text-foreground-500">
          {article.summary}
        </p>
        <div className="mt-3 flex flex-wrap gap-2">
          {article.tags.map((tag) => (
            <span
              key={tag}
              className="rounded bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}